/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type User = {
    organization_id?: string;
    user_id: string;
    role: User.role;
};

export namespace User {

    export enum role {
        ADMIN = 'admin',
        USER = 'user',
    }


}

